var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.8785 52.365C74.1844 39.7323 64.9981 28.4278 52.3654 27.1219C39.7327 25.8161 28.4282 35.0024 27.1223 47.635M31.0017 48.0361C32.0813 37.5917 41.4206 29.9113 51.9644 31.0012C62.5082 32.0912 70.0788 41.5196 68.9992 51.964",
    fill: "#005386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.fa19fcf26be52b87d8769307ab8c508b.svg";
export { ForwardRef as ReactComponent };